import { c as _c } from "react/compiler-runtime";
import { ProductNameTag, ProductNameTagProps } from 'modules/payment/transactions/components/transaction-payment-tooltip/product-name-tag';
export const ValueWithProductNameTag = t0 => {
  const $ = _c(8);
  const {
    value,
    type,
    t
  } = t0;
  let t1;
  if ($[0] !== value) {
    t1 = <div>{value}</div>;
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t || $[3] !== type) {
    t2 = <ProductNameTag type={type} t={t} />;
    $[2] = t;
    $[3] = type;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="flex flex-col items-start">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};